import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getLocalDateStr(date: Date = new Date()) {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Madrid" }).format(date);
}

export function workOrderTypeLabel(type?: string | null) {
  const labels: Record<string, string> = {
    installation: "Instalación",
    breakdown: "Avería",
    maintenance: "Mantenimiento",
  };

  if (!type) return "No especificado";
  return labels[type] || type;
}
